import { memo, useCallback, useEffect, useState } from 'react';

import Announcements from 'components/Announcements';
import PageTitle from 'components/PageTitle';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { analyticsG4 } from 'services/analyticsG4';
import hotjarService from 'services/hotjarService';
import { EmptyState } from 'shared/EmptyState';
import { Button } from 'shared/Houston';
import If from 'shared/If';
import { orderBumpFormActions } from 'store/features';
import { selectUser } from 'store/selectors';

import Add from '@eduzz/houston-icons/Add';

import List from './List';
import { ColumnWithoutSpacing, EmptyStateContainer, PageHeader } from './styles';

const MyOrderBumps: React.FC = () => {
  const [hasOrderBump, setHasOrderBump] = useState<boolean | undefined>(undefined);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(selectUser);

  const redirectToCreateOrderBump = useCallback(() => {
    dispatch(orderBumpFormActions.reset());
    navigate('/orderbump/create', { replace: true });
  }, [navigate, dispatch]);

  useEffect(() => {
    analyticsG4.sendPageView({ title: 'Checkout Sun - Bump' });
  }, []);

  useEffect(() => {
    if (!user.showSurvey) {
      return;
    }

    const timeoutId = setTimeout(() => {
      hotjarService.setUser(user);
      window.hj('event', 'orderbump');
    }, 300);

    return () => {
      clearTimeout(timeoutId);
    };
  });

  return (
    <>
      <Announcements />
      <PageHeader alignItems='center' justifyContent='space-between' spacing='compact'>
        <ColumnWithoutSpacing>
          <PageTitle title='Order Bump' />
        </ColumnWithoutSpacing>
        <ColumnWithoutSpacing md='auto' sm={12} xs={12}>
          <Button startIcon={<Add />} onClick={redirectToCreateOrderBump}>
            Novo Order Bump
          </Button>
        </ColumnWithoutSpacing>
      </PageHeader>
      <If condition={hasOrderBump === false}>
        <EmptyStateContainer>
          <EmptyState
            title='Você não possui nenhum Order Bump cadastrado '
            subtitle='Aumente suas vendas adicionando produtos complementares no checkout.'
          />
        </EmptyStateContainer>
      </If>

      <List handleSetHasOrderBump={setHasOrderBump} />
    </>
  );
};

export default memo(MyOrderBumps);
